<script>
import {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    HomeIcon,
    UserIcon,
    UserCheckIcon,
    MailIcon,
    KeyIcon,
    HashIcon
} from 'vue-feather-icons';
import config from "@/config.json";
import axios from 'axios';
import {post} from "@/assets/js/utils";
import Vue from "vue";

/**
 * Auth-signup component
 */
export default {
    data() {
        return {
          status: 0,
          from: 'Web.Mirror',
          email: "",
          password: "",
          captcha_code: "",
          code: "",
          accepted: false,
          showResend: true,
          loading: false,
          showTip: false,
          isSuccess: false,
          message: "",
          captcha: {
            img: "",
            key: "",
            sensitive: false
          }
        }
    },
    mounted() {
      if (location.hash !== "") {
        const arr = location.hash.match(/from=([\w\.-_]+)/);
        if (arr.length > 1) {
          this.from = arr[1];
        }
      }
      this.getCaptcha();
    },
  methods: {
      async resendMail() {
        try {
          const {email} = this;
          const data = await post(`${config.api.resend}`, {email, type: 1, app: "Design Mirror"});
          if (data.errno === 0) {
            this.showResend = false;
            setTimeout(() => { this.showResend = true; }, 60*1000);
          } else {
            this.showError(data.info);
          }
        } catch (e) {
          this.showError(e.toString());
        }
      },
      async verify() {
        if (this.code.trim() === "" || this.email.trim() === "") {
          return;
        }
        this.loading = true;
        try {
          const {email, code} = this;
          const params = {email, code, type: 1};
          const ak = localStorage.getItem("access_key");
          if (ak) {
            params['access_key'] = ak;
          }
          const data = await post(`${config.api.verify}`, params);
          this.loading = false;
          if (data.errno === 0) {
            localStorage.setItem("access_key", data['access_key']);
            localStorage.setItem("access_token", data['access_token']);
              this.showTip = true;
              this.isSuccess = true;
              this.message = this.$t('signup.token.success');
              setTimeout(() => {
                  this.$router.push('/');
              }, 1000);
          } else {
            this.showError(data.info);
          }
        } catch (e) {
          this.showError(e.toString());
        }
      },

      async signup() {
        if (this.email.trim() === "" || this.password.trim() === "" || this.accepted === false || this.captcha_code.trim() === "") {
          return;
        }
        this.loading = true;
        const {email, password, captcha_code, from} = this;
        try {
          const data = await post(`${config.api.register}`, {email, password, captcha_code, captcha_key: this.captcha.key, from});
          this.loading = false;
          if (data.errno === 0) {
            this.status = 1;
          } else {
            this.showError(data.info);
          }
        } catch (e) {
          this.showError(e.toString())
        }
      },
      async getCaptcha() {
        try {
          const data = await post(`${config.api.captcha}`, {});
          if (data.errno === 0) {
            this.captcha = data;
          }
        } catch (e) {
        }
      },
      showError(msg) {
        this.loading = false;
        this.showTip = true;
        this.isSuccess = false;
        this.message = msg;
        this.captcha_code = "";
        this.getCaptcha();
      }

    },
    components: {
        FacebookIcon,
        InstagramIcon,
        TwitterIcon,
        LinkedinIcon,
        HomeIcon,
        UserIcon,
        UserCheckIcon,
        MailIcon,
        KeyIcon,
      HashIcon
    }
}
</script>

<template>
<div>
    <!-- Loader -->
    <div class="back-to-home rounded d-none d-sm-block">
        <router-link to="/" class="btn btn-icon btn-soft-primary">
            <home-icon class="icons"></home-icon>
        </router-link>
    </div>

    <!-- Hero Start -->
    <section class="bg-auth-home d-table w-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-7 col-md-6">
                    <div class="mr-lg-5">
                        <img loading="eager" fetchpriority="high" src="/images/user/signup.svg" class="img-fluid d-block mx-auto" alt="">
                    </div>
                </div>
                <div class="col-lg-5 col-md-6">
                    <div class="card shadow rounded border-0">
                        <div class="card-body" v-if="status === 0">
                            <h2 class="h4 card-title text-center">{{$t('signup.title')}}</h2>
                            <form class="login-form mt-4" @submit.prevent="signup">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group ">
                                            <label>{{$t('signup.email')}} <span class="text-danger">*</span></label>
                                            <div class="position-relative">
                                            <mail-icon class="fea icon-sm icons"></mail-icon>
                                            <input @focus="showTip=false" v-model="email" type="email" class="form-control pl-5" :placeholder="$t('signup.emailTip')" name="email" required="">
                                        </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group ">
                                            <label>{{$t('signup.password')}} <span class="text-danger">*</span></label>
                                            <div class="position-relative">
                                            <key-icon class="fea icon-sm icons"></key-icon>
                                            <input @focus="showTip=false" v-model="password" type="password" class="form-control pl-5" :placeholder="$t('signup.passwordTip')" required="">
                                        </div>
                                        </div>
                                    </div>
                                  <div class="col-md-12">
                                    <div class="form-group ">
                                      <label>{{$t('signup.captcha')}} <span class="text-danger">*</span></label>
                                      <div class="row">
                                        <div class="position-relative col-md-6">
                                          <hash-icon class="fea icon-sm icons ml-3"></hash-icon>
                                          <input @focus="showTip=false" v-model="captcha_code" type="text" class="form-control pl-5" :placeholder="$t('signup.captcha_tip')" required="">
                                        </div>
                                        <div class="col-md-6" v-if="captcha.img !== ''">
                                          <img loading="lazy" :src="captcha.img" alt="" height="40"/>
                                          <a href="#" @click.prevent="getCaptcha" class="ml-2 btn btn-icon btn-pills btn-outline-dark"><i class="uil uil-sync"></i></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="custom-control custom-checkbox">
                                                <input v-model="accepted" type="checkbox" class="custom-control-input" id="customCheck1">
                                                <label class="custom-control-label" for="customCheck1">{{$t('signup.accept')}} <router-link to="/terms" target="_blank" class="text-primary">{{$t('signup.terms')}}</router-link></label>
                                            </div>
                                        </div>
                                    </div>
                                  <div class="col-md-12">
                                    <div v-if="showTip" class="alert " :class="{'alert-danger': !isSuccess, 'alert-success': isSuccess}" role="alert">
                                      <i v-if="isSuccess" class="uil uil-check"></i>
                                      <i v-if="!isSuccess" class="uil uil-times"></i>
                                      {{message}}
                                    </div>
                                    <button :disabled="loading" class="btn btn-primary btn-block">{{$t('signup.signup')}}</button>
                                    </div>
                                    <div class="mx-auto">
                                          <p class="mb-0 mt-3"><small class="text-dark mr-2">{{$t('signup.haveAccount')}}</small>
                                            <router-link to="/auth-login" class="text-primary font-weight-bold">{{$t('signup.signIn')}}</router-link>
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>

                      <div class="card-body" v-if="status === 1">
                        <h2 class="h4 card-title text-center">{{$t('signup.token.title')}}</h2>

                        <form class="login-form mt-4" @submit.prevent="verify">
                          <div class="row">
                            <div class="col-lg-12">
                              <p v-html="$t('signup.token.description', {email})"> </p>
                              <div class="form-group">
                                <label >{{$t('signup.captcha')}} <span class="text-danger">*</span></label >
                                <div class="row">
                                  <div class="col-md-6">
                                    <hash-icon class="ml-3 fea icon-sm icons"></hash-icon>
                                    <input
                                        @focus="showTip=false"
                                        v-model="code"
                                        type="text"
                                        class="form-control pl-5"
                                        :placeholder="$t('signup.token.token_tip')"
                                        name="code"
                                        required=""
                                    />
                                  </div>
                                  <div class="col-md-6">
                                    <a v-if="showResend" href="#" @click.prevent="resendMail" class="badge badge-primary"><i class="uil uil-sync"></i> {{$t('signup.token.resend_token')}}</a>
                                    <span style="font-size: 14px" v-if="!showResend" v-html="$t('signup.token.resend_tip')"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <div v-if="showTip" class="alert " :class="{'alert-danger': !isSuccess, 'alert-success': isSuccess}" role="alert">
                                <i v-if="isSuccess" class="uil uil-check"></i>
                                <i v-if="!isSuccess" class="uil uil-times"></i>
                                {{message}}
                              </div>
                              <button class="btn btn-primary btn-block">{{$t('signup.token.done')}}</button>
                            </div>
                          </div>
                        </form>
                      </div>

                    </div>
                </div>
                <!--end col-->




            </div>
            <!--end row-->
        </div>
        <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->
</div>
</template>
